import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { FamiliaService } from 'src/app/services/familia.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { debounceTime, filter } from 'rxjs/operators';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { DireccionService } from 'src/app/services/direccion.service';
import { TipoClienteService } from 'src/app/services/tipo-cliente.service';
import { SucursalService } from 'src/app/services/sucursal.service';
import { MaquinaMovimientoService } from 'src/app/services/maquina-movimiento.service';
import { TipoDestinatarioService } from 'src/app/services/tipo-destinatario.service';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
@Component({
  selector: 'app-maquinas-maestro-modal-asignar',
  templateUrl: './modal-asignar.component.html',
  styleUrls: ['../maquinas-maestro.component.scss'],
  providers: [SecurityService],
})
export class MaquinasMaestroModalAsignarComponent implements OnInit {
  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent;
  @ViewChild('asignarMaquina', { static: true }) asignarMaquinaModal: ModalDirective;
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>();

  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rutUsuario: number;
  cliente: any = null;
  proveedorSeleccionado: any = null;

  direccion: any = null;

  optionsSucursalEmpresa: Array<any> = [];
  optionsTipoDoc: Array<any> = [];
  optionsTipoDocGarantia: Array<any> = [];
  optionsSucursal: Array<any> = [];
  optionsTipoDestinatario: Array<any> = [];
  headerData: any = {};

  showPanels = {
    descMov: false,
    garantia: false,
    entrega: false,
  };

  // Utils
  private log: any;

  movimiento: any = null;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private sucursalService: SucursalService,
    private familiaService: FamiliaService,
    private tipoDTEService: TipoDTEService,
    private datesService: DatesService,
    private direccionService: DireccionService,
    private tipoClienteService: TipoClienteService,
    private maquinaMovimientoService: MaquinaMovimientoService,
    private tipoDestinatarioService: TipoDestinatarioService
  ) {
    this.log = this.clog.log('MAQUINAS ASIGNAR');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    // this.loadSucursalEmpresa()
    this.loadTiposDte();
    this.loadTiposDteGarantia();
    this.createForms();
    this.formChangesSubscriptions();
  }

  // loadSucursalEmpresa() {
  //   const inputParams = {
  //     rut_empresa: this.rutEmpresa
  //   }
  //   this.sucursalService.obtenerSucursalxEmpresa(inputParams, ({ mensajes, respuesta }) => {
  //     const ok = respuesta !== null
  //     if (!ok) {
  //       this.messageRendererService.showErrors(mensajes)
  //       return
  //     }
  //     const { registros } = respuesta
  //     this.optionsSucursalEmpresa = registros.map(p => ({ value: p.codigo, label: p.nombre, ...p }))
  //   })
  // }

  /** Solo guía de despacho (SII 52), descripción GD — único tipo permitido en asignación. */
  private static readonly CODIGO_GUIA_DESPACHO = 52;
  /** Texto visible en el combo (mismo criterio que antes: `nombre` del tipo DTE). */
  private static readonly NOMBRE_GUIA_DESPACHO_FALLBACK = 'Guía de despacho';

  loadTiposDte() {
    this.tipoDTEService.obtenerTipoCompra(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.optionsTipoDoc = [
          {
            value: MaquinasMaestroModalAsignarComponent.CODIGO_GUIA_DESPACHO,
            label: MaquinasMaestroModalAsignarComponent.NOMBRE_GUIA_DESPACHO_FALLBACK,
            codigo: MaquinasMaestroModalAsignarComponent.CODIGO_GUIA_DESPACHO,
            nombre: MaquinasMaestroModalAsignarComponent.NOMBRE_GUIA_DESPACHO_FALLBACK,
          },
        ];
        return;
      }
      const { registros } = respuesta;
      const guia = (registros || []).find((p) => Number(p.codigo) === MaquinasMaestroModalAsignarComponent.CODIGO_GUIA_DESPACHO);
      const nombreApi = guia && guia.nombre ? String(guia.nombre).trim() : '';
      const nombreMostrar =
        nombreApi && nombreApi.toUpperCase() !== 'GD'
          ? nombreApi
          : MaquinasMaestroModalAsignarComponent.NOMBRE_GUIA_DESPACHO_FALLBACK;
      this.optionsTipoDoc = guia
        ? [{ value: guia.codigo, label: nombreMostrar, nombre: guia.nombre, ...guia }]
        : [
            {
              value: MaquinasMaestroModalAsignarComponent.CODIGO_GUIA_DESPACHO,
              label: MaquinasMaestroModalAsignarComponent.NOMBRE_GUIA_DESPACHO_FALLBACK,
              codigo: MaquinasMaestroModalAsignarComponent.CODIGO_GUIA_DESPACHO,
              nombre: MaquinasMaestroModalAsignarComponent.NOMBRE_GUIA_DESPACHO_FALLBACK,
            },
          ];
    });
  }

  loadTiposDteGarantia() {
    this.tipoDTEService.obtenerTipoDocGarantia(({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsTipoDocGarantia = registros.map((p) => ({ value: p.codigo, label: p.nombre, ...p }));
    });
  }

  /** Tipo DTE del movimiento fijo (52 / GD): no se permite cambiar desde el UI. */
  private bloquearMovimientoTipoDteGuia(): void {
    const c = this.formHeader.get('movimiento.tipoDte');
    if (!c) return;
    c.disable({ emitEvent: false });
  }

  private createForms() {
    this.formHeader = this.fb.group({
      fecha: [null, [Validators.required]],
      // sucursal: [null, [Validators.required]],
      destinatario: this.fb.group({
        tipoDestinatario: [null],
        rutCliente: [null],
        rutProveedor: [null],
        sucursal: [null],
        observacion: [null, []],
      }),
      movimiento: this.fb.group({
        tipoDte: [null, []],
        nroDoc: [null, []],
        descripcion: [null, []],
        fecha: [null, []],
        generar_guia: [null, []]
      }),
      garantia: this.fb.group({
        tipoDte: [null, []],
        nroDoc: [null, []],
        fecha: [null, []],
        contrato: [false, []],
        nroContrato: [null, []], // ADD/REMOVE dinamically Validators.required
        fechaDoc: [null, []], // ADD/REMOVE dinamically Validators.required
        fechaVigenciaDesde: [null, []], // ADD/REMOVE dinamically Validators.required
        fechaVigenciaHasta: [null, []], // ADD/REMOVE dinamically Validators.required
      }),
      entrega: this.fb.group({
        fechaConfirmacion: [null, []],
        esMovimientoCerrado: [false, []],
      }),
    });
  }

  setValidatorsMovimiento(operation: 'ADD' | 'DELETE') {
    this.formHeader.get('movimiento').markAsPristine();
    this.formHeader.get('movimiento').markAsUntouched();

    this.formHeader.get('movimiento.tipoDte').setValidators(operation === 'ADD' ? [] : []);
    this.formHeader.get('movimiento.nroDoc').setValidators(operation === 'ADD' ? [] : []);
    this.formHeader.get('movimiento.fecha').setValidators(operation === 'ADD' ? [Validators.required] : []);
    this.formHeader.get('movimiento.descripcion').setValidators(operation === 'ADD' ? [] : []);

    this.formHeader.get('movimiento.tipoDte').updateValueAndValidity();
    this.formHeader.get('movimiento.nroDoc').updateValueAndValidity();
    this.formHeader.get('movimiento.fecha').updateValueAndValidity();

  }

  setValidatorsGarantia(operation: 'ADD' | 'DELETE') {
    this.formHeader.get('garantia').markAsPristine();
    this.formHeader.get('garantia').markAsUntouched();

    this.formHeader.get('garantia.tipoDte').setValidators(operation === 'ADD' ? [] : []);
    this.formHeader.get('garantia.nroDoc').setValidators(operation === 'ADD' ? [] : []);
    this.formHeader.get('garantia.fecha').setValidators(operation === 'ADD' ? [Validators.required] : []);
    this.formHeader.get('garantia.contrato').setValidators(operation === 'ADD' ? [Validators.required] : []);

    this.formHeader.get('garantia.tipoDte').updateValueAndValidity();
    this.formHeader.get('garantia.nroDoc').updateValueAndValidity();
    this.formHeader.get('garantia.fecha').updateValueAndValidity();
    this.formHeader.get('garantia.contrato').updateValueAndValidity();

    if (operation === 'DELETE') {
      this.setValidatorsGarantiaContrato(operation);
    }
  }

  setValidatorsGarantiaContrato(operation: 'ADD' | 'DELETE') {
    const now = this.datesService.CurrentDateToShortTimeString();

    this.log('setValidatorsGarantiaContrato', operation);
    this.formHeader.get('garantia.nroContrato').setValidators(operation === 'ADD' ? [Validators.required] : []);
    this.formHeader.get('garantia.fechaDoc').setValidators(operation === 'ADD' ? [Validators.required] : []);
    this.formHeader.get('garantia.fechaVigenciaDesde').setValidators(operation === 'ADD' ? [Validators.required] : []);
    this.formHeader.get('garantia.fechaVigenciaHasta').setValidators(operation === 'ADD' ? [Validators.required] : []);

    this.formHeader.get('garantia.nroContrato').updateValueAndValidity();
    this.formHeader.get('garantia.fechaDoc').updateValueAndValidity();
    this.formHeader.get('garantia.fechaVigenciaDesde').updateValueAndValidity();
    this.formHeader.get('garantia.fechaVigenciaHasta').updateValueAndValidity();

    this.formHeader.get('garantia.fechaDoc').setValue(now);
    this.formHeader.get('garantia.fechaVigenciaDesde').setValue(now);
    this.formHeader.get('garantia.fechaVigenciaHasta').setValue(now);
  }

  setValidatorsEntrega(operation: 'ADD' | 'DELETE') {
    this.formHeader.get('entrega').markAsPristine();
    this.formHeader.get('entrega').markAsUntouched();

    this.formHeader.get('entrega.fechaConfirmacion').setValidators(operation === 'ADD' ? [Validators.required] : []);
    this.formHeader.get('entrega.esMovimientoCerrado').setValidators(operation === 'ADD' ? [Validators.required] : []);

    this.formHeader.get('entrega.fechaConfirmacion').updateValueAndValidity();
    this.formHeader.get('entrega.esMovimientoCerrado').updateValueAndValidity();
  }

  formChangesSubscriptions() {
    this.formHeader.get('destinatario.tipoDestinatario').valueChanges.subscribe((tipoDestinatario) => {
      this.log('tipoDestinatario', tipoDestinatario);
      this.setValidatorsMovimiento('DELETE');
      this.setValidatorsGarantia('DELETE');
      this.setValidatorsGarantiaContrato('DELETE');
      this.setValidatorsEntrega('DELETE');

      this.formHeader.get('destinatario.rutCliente').setValidators([]);
      this.formHeader.get('destinatario.rutProveedor').setValidators([]);
      this.formHeader.get('destinatario.sucursal').setValidators([]);
      switch (tipoDestinatario) {
        case 3:
          // TALLER DE REPARACION - 3

          this.showPanels.descMov = true;
          this.showPanels.garantia = false;
          this.showPanels.entrega = true;

          break;
        case 99:
          // PROVEEDOR - 99
          this.showPanels.descMov = true;
          this.showPanels.garantia = false;
          this.showPanels.entrega = true;
          this.formHeader.get('destinatario.rutProveedor').setValidators([Validators.required]);
          break;
        case 1:
          // CENTRO DE DISTRIBUCION
          this.showPanels.descMov = true;
          this.showPanels.garantia = false;
          this.showPanels.entrega = true;
          break;
        case 2:
          // CLIENTE 2
          this.showPanels.descMov = true;
          this.showPanels.garantia = true;
          this.showPanels.entrega = true;
          this.formHeader.get('destinatario.rutCliente').setValidators([Validators.required]);
          this.formHeader.get('destinatario.sucursal').setValidators([Validators.required]);
          this.formHeader.get('destinatario.tipoDestinatario').setValidators([Validators.required]);
          break;
        //SIN ASIGNAR - 0
        default:
          this.showPanels.descMov = false;
          this.showPanels.garantia = false;
          this.showPanels.entrega = false;
          this.cliente = null;
          this.formHeader.get('destinatario.rutCliente').setValue(null);
          break;
      }

      this.formHeader.get('destinatario.rutCliente').updateValueAndValidity();
      this.formHeader.get('destinatario.rutProveedor').updateValueAndValidity();
      this.formHeader.get('destinatario.sucursal').updateValueAndValidity();

      if (this.showPanels.descMov) this.setValidatorsMovimiento('ADD');
      if (this.showPanels.garantia) this.setValidatorsGarantia('ADD');
      if (this.showPanels.entrega) this.setValidatorsEntrega('ADD');
    });

    this.formHeader
      .get('destinatario.rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
        this.modalSeleccionarCliente.cleanLast();
      });

    // buscar rut en modal proveedor
    this.formHeader
      .get('destinatario.rutProveedor')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rut: string) => {
        this.log(rut);
        //const _rut = this.rutService.QuitarDV(this.rutService.Limpiar(rut))
        this.modalSeleccionarProveedor.searchByRut(rut);
      });

    this.formHeader.get('destinatario.sucursal').valueChanges.subscribe((direccion) => this.handleDireccionChange(direccion));

    this.formHeader.get('garantia.contrato').valueChanges.subscribe((contrato: boolean) => {
      if (contrato) {
        this.formValidatorsService.resetField(this.formHeader, 'garantia.nroContrato');
        this.formValidatorsService.resetField(this.formHeader, 'garantia.fechaDoc');
        this.formValidatorsService.resetField(this.formHeader, 'garantia.fechaVigenciaDesde');
        this.formValidatorsService.resetField(this.formHeader, 'garantia.fechaVigenciaHasta');

        this.setValidatorsGarantiaContrato('ADD');
      } else {
        this.setValidatorsGarantiaContrato('DELETE');
      }
    });
    this.formHeader.get('movimiento.tipoDte').valueChanges.subscribe((tipoDTE: number) => {
      if (tipoDTE === 52 && this.formHeader.get('movimiento.generar_guia').value === true) {
        this.formHeader.get('movimiento.descripcion').setValidators([Validators.required]);
      } else {
        this.formHeader.get('movimiento.descripcion').setValidators([]);
      }
      this.formHeader.get('movimiento.descripcion').updateValueAndValidity();
    });

    this.formHeader.get('movimiento.generar_guia').valueChanges.subscribe((generaGuia: boolean) => {
      if (generaGuia === true && this.formHeader.get('movimiento.tipoDte').value === 52) {
        this.formHeader.get('movimiento.descripcion').setValidators([Validators.required]);
      } else {
        this.formHeader.get('movimiento.descripcion').setValidators([]);
      }
      this.formHeader.get('movimiento.descripcion').updateValueAndValidity();
    });
  }

  private handleDireccionChange(value) {
    if (!this.cliente || !this.optionsSucursal) return;

    this.direccion = this.optionsSucursal.filter((p) => p.value === value)[0];
  }

  show(mov: any) {
    this.resetAndSetDefaults();
    this.movimiento = mov;

    this.getDestinatariosFiltro(mov);
    this.setInitialValues(mov);
    this.asignarMaquinaModal.show();
  }

  getDestinatariosFiltro(mov) {
    const inputParams = {
      maq: { empresa_rut: this.rutEmpresa, numero_placa: mov.numero_placa },
      paginaActual: 1,
      cantidadRegistrosxPagina: 50,
    };

    this.tipoDestinatarioService.ObtenerDestinatariosSegunOrigen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsTipoDestinatario = registros.filter((p) => p.codigo > 0).map((p) => ({ value: p.codigo, label: p.nombre, ...p }));
    });
  }

  setInitialValues(mov: any) {
    const now = this.datesService.CurrentDateToShortTimeString();
    this.formHeader.get('fecha').setValue(now);
    // this.formHeader.get('sucursal').setValue(null)

    this.formHeader.get('destinatario.sucursal').setValue(null);
    this.formHeader.get('destinatario.observacion').setValue(null);
    this.formHeader.get('movimiento.tipoDte').setValue(MaquinasMaestroModalAsignarComponent.CODIGO_GUIA_DESPACHO);
    this.bloquearMovimientoTipoDteGuia();
    this.formHeader.get('movimiento.nroDoc').setValue(null);
    this.formHeader.get('movimiento.fecha').setValue(now);
    this.formHeader.get('movimiento.generar_guia').setValue(false);
    this.formHeader.get('garantia.tipoDte').setValue(null);
    this.formHeader.get('garantia.nroDoc').setValue(null);
    this.formHeader.get('garantia.fecha').setValue(now);
    this.formHeader.get('garantia.contrato').setValue(false);
    this.formHeader.get('garantia.nroContrato').setValue(null);

    this.formHeader.get('garantia.fechaDoc').setValue(now);
    this.formHeader.get('garantia.fechaVigenciaDesde').setValue(now);
    this.formHeader.get('garantia.fechaVigenciaHasta').setValue(now);

    this.formHeader.get('entrega.fechaConfirmacion').setValue(now);
    this.formHeader.get('entrega.esMovimientoCerrado').setValue(false);

    this.formHeader.get('destinatario.rutCliente').setValue(null);

    switch (mov.tipo_destinatario_codigo) {
      case 1:
        // CENTRO DE DISTRIBUCION
        this.formHeader.get('destinatario.tipoDestinatario').setValue(2);
        this.formHeader.get('destinatario.rutProveedor').setValue(this.rutService.AgregarDV(mov.proveedor_rut));
        break;
      case 2:
        // CLIENTE
        this.formHeader.get('destinatario.tipoDestinatario').setValue(2);
        this.formHeader.get('destinatario.rutProveedor').setValue(null);
        break;
      case 3:
        // TALLER DE REPARACION
        this.formHeader.get('destinatario.tipoDestinatario').setValue(1);
        this.formHeader.get('destinatario.rutProveedor').setValue(null);
        break;
      case 99:
        // PROVEEDOR
        this.formHeader.get('destinatario.tipoDestinatario').setValue(null);
        this.formHeader.get('destinatario.rutProveedor').setValue(this.rutService.AgregarDV(mov.proveedor_rut));
        break;
      default:
        // SIN ASIGNAR
        this.formHeader.get('destinatario.tipoDestinatario').setValue(null);
        this.formHeader.get('destinatario.rutProveedor').setValue(null);
        break;
    }
  }

  resetAndSetDefaults() {
    // this.dpFechaMain.clearDtate()
    this.formValidatorsService.reset(this.formHeader);

    // remove dynamic validators
    this.setValidatorsMovimiento('DELETE');
    this.setValidatorsGarantia('DELETE');
    this.setValidatorsGarantiaContrato('DELETE');
    this.setValidatorsEntrega('DELETE');

    // set defaults
    // const now = this.datesService.CurrentDateToShortTimeString()
    // this.formHeader.get('fechaMain').setValue(now)

    this.cliente = null;
    this.proveedorSeleccionado = null;

    this.modalSeleccionarCliente.cleanLast();
  }

  openModalSeleccionarcliente() {
    this.modalSeleccionarCliente.show();
  }

  openModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show();
  }

  onProveedorSeleccionado({ data: _proveedorSeleccionado, origen }) {
    this.proveedorSeleccionado = _proveedorSeleccionado;
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut);
    this.formHeader.get('destinatario.rutProveedor').setValue(this.proveedorSeleccionado.rutFormato);
    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado);
    // this.modalSeleccionarProveedor.clearLast()
  }

  onProductoNoEncontrado() {
    this.clearProveedorSeleccionadoData();
  }

  clearProveedorSeleccionadoData() {
    this.proveedorSeleccionado = null;
    this.formHeader.get('destinatario.rutProveedor').setValue(null);
  }

  onClienteSeleccionado({ data, origen }) {
    // * SI ESTOY UBICADO COMO ORIGEN EN CLIENTE - NO AUTOCOMPLETAR INPUT EN CASO CONTRARIO COMPLETAR */
    this.cliente = data;
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut);
    this.formHeader.get('destinatario.rutCliente').setValue(this.cliente.rutFormato);
    this.fetchSucursal(this.cliente.rut);
  }

  onClienteNoEncontrado() {
    // rut vacio
    this.formHeader.get('destinatario.rutCliente').setValue(null);

    //direccion por defecto
    this.optionsSucursal = [];
    this.formHeader.get('destinatario.sucursal').setValue(null);
    this.cliente = null;

    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('destinatario.sucursal'), this.optionsSucursal);
  }

  private limpiarDataSeleccionada() {
    this.formHeader.get('rutCliente').setValue(null);
    this.cliente = {};
  }

  disableUnidadNegocio(unidad_negocio_codigo: number | null) {
    if (unidad_negocio_codigo) this.formHeader.get('unidad_negocio_codigo').setValue(unidad_negocio_codigo);
    this.formHeader.get('unidad_negocio_codigo').disable();
  }

  private fetchSucursal(cliente_proveedor_rut) {
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      // sucursal_codigo: this.sucursalCodigo,
      cliente_proveedor_rut,
    };

    // DEBERIA IR NOMBRE DE LA SUCURSAL, PRINCIPAL - ENTRE OTRAS
    this.log('fetch sucursal', JSON.stringify(inputParams));
    this.direccionService.GetByCliente(inputParams, ({ registros }) => {
      this.optionsSucursal = registros.map((direccion) => ({
        value: direccion.codigo,
        label: direccion.direccion_completa,
        ...direccion,
      }));

      // console.log("***** O?PTIOPN S[UCURSAL ", this.optionsSucursal)

      // Seleccionar el primer valor en las opciones de la direccion para el destinatario
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('destinatario.sucursal'), this.optionsSucursal);
    });
  }

  private resolverClienteProveedorRutParaEntidad(
    tipoDestinatario: number,
    rutCliente: number | null,
    rutProveedor: number | null
  ): number | null {
    if (tipoDestinatario === 1) {
      return null;
    }
    if (tipoDestinatario === 99) {
      return rutProveedor;
    }
    return rutCliente;
  }

  private resolverDireccionCodigoDestinatario(tipoDestinatario: number, sucursalCodigo: any): any {
    if (tipoDestinatario === 1) {
      return null;
    }
    return sucursalCodigo;
  }

  private textoObservacionDestinatario(observacion: any): string {
    return observacion ? observacion : '';
  }

  private aplicarDatosGarantiaEnEntidad(entidad: any, garantia: any): void {
    entidad.tipo_garantia_codigo = garantia.tipoDte;
    entidad.nro_documento_garantia = garantia.nroDoc;
    entidad.fecha_garantia = garantia.fecha;
    if (garantia.contrato) {
      entidad.numero_contrato = garantia.nroContrato;
      entidad.fecha_contrato = garantia.fechaDoc;
      entidad.fecha_vigencia_contrato = garantia.fechaVigenciaDesde;
      entidad.fecha_termino_contrato = garantia.fechaVigenciaHasta;
    }
  }

  guardar() {
    if (!this.formHeader.valid) {
      this.log('fecha', this.formHeader.get('fecha').valid);
      // this.log('sucursal', this.formHeader.get('sucursal').valid)
      this.log('destinatario.tipoDestinatario', this.formHeader.get('destinatario.tipoDestinatario').valid);
      this.log('destinatario.rutCliente', this.formHeader.get('destinatario.rutCliente').valid);
      this.log('destinatario.sucursal', this.formHeader.get('destinatario.sucursal').valid);
      this.log('destinatario.observacion', this.formHeader.get('destinatario.observacion').valid);
      this.log('movimiento.tipoDte', this.formHeader.get('movimiento.tipoDte').valid);
      this.log('movimiento.nroDoc', this.formHeader.get('movimiento.nroDoc').valid);
      this.log('movimiento.fecha', this.formHeader.get('movimiento.fecha').valid);
      this.log('garantia.tipoDte', this.formHeader.get('garantia.tipoDte').valid);
      this.log('garantia.nroDoc', this.formHeader.get('garantia.nroDoc').valid);
      this.log('garantia.fecha', this.formHeader.get('garantia.fecha').valid);
      this.log('garantia.contrato', this.formHeader.get('garantia.contrato').valid);
      this.log('garantia.nroContrato', this.formHeader.get('garantia.nroContrato').valid);
      this.log('garantia.fechaDoc', this.formHeader.get('garantia.fechaDoc').valid);
      this.log('garantia.fechaVigenciaDesde', this.formHeader.get('garantia.fechaVigenciaDesde').valid);
      this.log('garantia.fechaVigenciaHasta', this.formHeader.get('garantia.fechaVigenciaHasta').valid);
      this.log('entrega.fechaConfirmacion', this.formHeader.get('entrega.fechaConfirmacion').valid);
      this.log('entrega.esMovimientoCerrado', this.formHeader.get('entrega.esMovimientoCerrado').valid);
      this.log('movimiento.descripcion', this.formHeader.get('movimiento.descripcion').valid);
      this.formHeader.markAllAsTouched();
      return;
    }

    // getRawValue: incluye controles deshabilitados y evita perder nested groups; fecha entrega debe ser la del picker, no un valor stale.
    const { fecha, destinatario, movimiento, garantia, entrega } = this.formHeader.getRawValue();

    const rut_cliente = this.rutService.QuitarDV(this.rutService.Limpiar(destinatario.rutCliente));

    const rut_proveedor = this.rutService.QuitarDV(this.rutService.Limpiar(destinatario.rutProveedor));

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        rut_usuario: this.rutUsuario,
        numero_placa: this.movimiento.numero_placa,

        cliente_proveedor_rut: this.resolverClienteProveedorRutParaEntidad(
          destinatario.tipoDestinatario,
          rut_cliente,
          rut_proveedor
        ),
        direccion_codigo: this.resolverDireccionCodigoDestinatario(
          destinatario.tipoDestinatario,
          destinatario.sucursal
        ),

        tipo_destinatario_destino_codigo: destinatario.tipoDestinatario,
        observacion: this.textoObservacionDestinatario(destinatario.observacion),
        fecha_asignacion: fecha,

        // movimiento
        tipo_dte_codigo: null,
        numero_documento_movimiento: null,
        descripcion_glosa: null,
        generar_guia: false,

        // contrato
        tipo_garantia_codigo: null,
        nro_documento_garantia: null,
        fecha_garantia: null,
        numero_contrato: null,
        fecha_contrato: null,
        fecha_vigencia_contrato: null,
        fecha_termino_contrato: null,

        // entrega
        cerrado: null,
        fecha_entrega: null,

        fecha_documento_detalle_compra: null as string | Date | null,
      },
    };

    if (this.showPanels.descMov) {
      inputParams.entidad.tipo_dte_codigo = movimiento.tipoDte;
      inputParams.entidad.numero_documento_movimiento = movimiento.nroDoc;
      inputParams.entidad.descripcion_glosa = movimiento.descripcion;
      inputParams.entidad.generar_guia = movimiento.generar_guia;
      inputParams.entidad.fecha_documento_detalle_compra =
        movimiento.fecha != null ? movimiento.fecha : null;
    }

    if (this.showPanels.garantia) {
      this.aplicarDatosGarantiaEnEntidad(inputParams.entidad, garantia);
    }

    if (this.showPanels.entrega) {
      inputParams.entidad.cerrado = entrega.esMovimientoCerrado;
      inputParams.entidad.fecha_entrega = entrega.fechaConfirmacion;
    }

    this.log('inputParams', JSON.stringify(inputParams));

    this.maquinaMovimientoService.guardar(inputParams, ({ mensajes, respuesta }) =>
      this.procesarRespuestaGuardarMovimiento(mensajes, respuesta)
    );
  }

  private procesarRespuestaGuardarMovimiento(mensajes: any, respuesta: any): void {
    const ok = respuesta !== null;
    if (!ok) {
      this.messageRendererService.showErrors(mensajes);
      return;
    }

    const tipoDestinatariosPermitidos: number[] = [1, 2, 99];
    if (
      tipoDestinatariosPermitidos.includes(respuesta.tipo_destinatario_destino_codigo) &&
      respuesta.tipo_dte_codigo === 52
    ) {
      this.toastService.success('Se generó guía despacho Nro.' + respuesta.numero_documento_movimiento);
    } else {
      this.toastService.success('Operación realizada');
    }

    this.onSuccess.emit();
    this.asignarMaquinaModal.hide();
    this.movimiento = null;
  }
}
